import { combineReducers } from 'redux-immutable'

import data from './data'

export default combineReducers({
  data
})
